export const idleTimeTopLimit        = 3600;  // 1 hour
export const sessionDurationTopLimit = 43200; // 12 hours